<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-product size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Product</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(category)="data">
                  {{ data.item.category.name }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.category.id,data.item.min_quantity )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-product" centered title="New Product  " title-class="font-18" hide-footer>
          <form @submit.prevent="addProduct">
              <div class="form-group mb-2">
              <label>Product Name</label>
              <input v-model="name" type="text" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Category</label>
              <b-form-select v-model="category" required :options="productcategories" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Unit</label>
              <b-form-select v-model="unit" required :options="productunits" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Price</label>
              <input v-model="price" type="number" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Current Stock</label>
              <input v-model="quantity" type="number" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Min Quantity</label>
              <input v-model="min_quantity" type="number" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-product')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-product" centered title="Edit Product  " title-class="font-14" hide-footer>
          <form @submit.prevent="editProduct">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Product Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Category</label>
              <b-form-select v-model="category" :options="productcategories" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Min Quantity</label>
              <input v-model="min_quantity" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-product')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-product" centered title="Delete Product  " title-class="font-18" hide-footer>
          <form @submit.prevent="removeProduct">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the  Product : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-product')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { productcategoryMethods , unitsMethods , productMethods, productcategoryComputed, unitsComputed, productComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Pharmacy Products",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        title: "Pharmacy Products",
        items: [ {text: "Dashboard",to: "/",}, {text: "Pharmacy Products",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'category', label: 'Category', visible: true },
            { key: 'min_quantity', label: 'Min Quantity', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'addedon', label: 'Added on', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        category:'',
        unit:'',
        quantity:'0',
        price:'',
        min_quantity:'0',
      };
    },
    computed: {
      ...productComputed,
      ...productcategoryComputed,
      ...unitsComputed,
      List() { return this.products.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.products.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.products.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchProducts();
      this.fetchCategories();
      this.fetchUnits();
      this.TotalRows = this.products.length;
      this.isBusy=false;
    },
    methods: {
      ...productMethods,
      ...productcategoryMethods,
      ...unitsMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,category,min_quantity){
        this.id=id;
        this.name=name;
        this.category=category;
        this.min_quantity=min_quantity;
        this.$bvModal.show('edit-product')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-product')
      },
      async addProduct() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("category", this.category);
        formData.append("unit", this.unit);
        formData.append("quantity", this.quantity);
        formData.append("price", this.price);
        formData.append("min_quantity", this.min_quantity);
        let url = "/addproduct";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchProducts();
            this.$bvModal.hide('new-product');
            this.name="";
            this.category="";
            this.quantity="";
            this.price="";
            this.min_quantity="";
        }
        });
      },
      async editProduct(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("category", this.category);
      formData.append("min_quantity", this.min_quantity);
      let url = "/updateproduct";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide('edit-product');
          this.name="";
          this.category="";
          this.min_quantity="";
        }
      });
      },
      async removeProduct() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeproduct";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide('delete-product');
        }
      });
      },
    },
  };
  </script>